<template>
    <div class="single-view">
        <the-loader v-if="!dataLoaded"></the-loader>
        <transition name="fade" mode="out-in">
            <section class="section view-single-sniadania" v-if="dataLoaded">
                <div class="container">
                    <div class="columns">
                        <div class="column view-single-sniadania__header-start">
                            <a class="button-more button-more--back" :href="$router.resolve({ name: 'home'}).href" @click.prevent="$router.push('/')">Powrót</a>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="content">
                                <h1 class="title">{{ post.title.rendered }}</h1>
                                <p>
                                    W imieniu SSW Pragmatic Solutions zapraszamy Państwa na cykl śniadań, podczas których poruszymy najbardziej gorące tematy podatkowe i prawne 2018 roku, przybliżymy Państwu obecnie obowiązujące i planowane zmiany regulacji oraz ich wpływ na działalność biznesową przedsiębiorstw. Przedstawimy praktyki oraz indywidualne rozwiązania, które mogą pomóc firmom odpowiednio przygotować się na nadchodzące zmiany tak, aby utrzymać efektywność i opłacalność prowadzonego biznesu oraz zmaksymalizować korzyści z dozwolonej optymalizacji obciążeń podatkowych.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <hr />
                        </div>
                    </div>
                    <div class="columns is-vcentered">
                        <div class="column view-single-sniadania__city">
                            <div class="columns is-centered">
                                <div class="column is-10">
                                    <img src="@/../public/img/card-header.png" alt="">
                                    <div class="content">
                                        <p><span>Warszawa</span><br />Rondo ONZ 1, 12 piętro</p>
                                        <p><span>Poznań</span><br />ul. Mielżyńskiego 14, Okrąglak 7 piętro</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="content">
                                <h2 class="title is-5">Śniadania będą się odbywać w dwóch miastach: w Warszawie i Poznaniu.</h2>
                                <ul>
                                    <li>Udział w nich jest bezpłatny.</li>
                                    <li>Spotkania będą prowadzone w języku polskim.</li>
                                    <li>Nadesłanie zgłoszenia nie jest równoznaczne z jego przyjęciem.</li>
                                    <li>Liczba miejsc jest ograniczona.</li>
                                    <li>Potwierdzenie przyjęcia zgłoszenia oraz agenda zostaną wysłane na podany adres e-mail.</li>
                                    <li>SSW Pragmatic Solutions zastrzega sobie prawo do odwołania bądź zmiany terminu poszczególnych spotkań.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <hr />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <iframe
                                ref="iframeContent"
                                src="https://analytics-eu.clickdimensions.com/sswpl-aq1k7/pages/fuk1ldtheeibuuahg24pyq.html"
                                width="100%"
                                height="100%"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <flexible-content
            v-if="dataLoaded"
            :pages="blocks"
            :current-page="'footer'"
        >
        </flexible-content>
        <transition name="fade" mode="out-in">
            <the-footer v-if="dataLoaded"></the-footer>
        </transition>
    </div>
</template>

<script>
import axios from 'axios'
import FlexibleContent from '@/components/FlexibleContent.vue'
import TheFooter from '../components/TheFooter.vue'
import TheLoader from '../components/TheLoader.vue'
export default {
    name: 'single-component-sniadania',
    components: {
        'flexible-content': FlexibleContent,
        'the-footer': TheFooter,
        'the-loader': TheLoader,
    },
    metaInfo(){
        return {
            title: this.title
        }
    },
    props: {
        blocks: Object,
    },
    data(){
        return {
            post: Object,
            dataLoaded: false,
            frame: null,
            title: String
        }
    },
    methods: {
        load(){
            axios.get(process.env.VUE_APP_API+'wp-json/wp/v2/sniadania/?slug='+this.$route.params.id)
            .then((response) => {
                this.post = response.data[0]
                this.dataLoaded = true
                this.title = this.post.title.rendered
            })
            .catch((error) => {
                console.log(error)
            })
        }
    },
    created() {
        this.load();
        window.addEventListener('message', function(e) {
});
    }
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.view-single-sniadania
    background-color: $white
    &__header-start
        display: flex
        align-items: center
        position: relative
        +mobile
            display: block
        .button-more
            position: absolute
            left: 0.75rem
            top: 0.75rem
            +mobile
                position: static
                width: 100%
                margin-bottom: 20px
    &__city
        img
            display: block
        .content
            background-color: $blue
            padding: 1rem 2rem
            p
                margin: 0
                color: $white
                border-bottom: 1px solid  $blue1
                font-size: $size-5
                padding-bottom: 1rem
                &:last-child
                    border-bottom: 0
                    padding-top: 1rem
                span
                    font-size: $size-6
                    color: $blue1
    iframe
        height: 65rem
</style>
